import { AuthLayout } from '@/modules/auth/ui/components'
import type { SetSession } from '@/modules/auth/use-cases'
import { useCompleteSetupPage } from './hooks/use-complete-setup-page'

export type CompleteSetupPageProps = {
  onSetSession: SetSession
}

export function CompleteSetupPage({ onSetSession }: CompleteSetupPageProps) {
  useCompleteSetupPage({ onSetSession })

  return (
    <AuthLayout title="Finishing setup…" subtitle="Hang tight while we sign you in.">
      <div
        data-testid="complete-setup-loading"
        className="flex items-center justify-center py-6"
      >
        <span className="text-sm text-muted-foreground">Just a moment…</span>
      </div>
    </AuthLayout>
  )
}
